"use strict";

var _regeneratorRuntime = require("/opt/build/repo/node_modules/@babel/runtime/regenerator/index.js");

var _asyncToGenerator = require("/opt/build/repo/node_modules/@babel/runtime/helpers/asyncToGenerator.js");

var _slicedToArray = require("/opt/build/repo/node_modules/@babel/runtime/helpers/slicedToArray.js");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));

var _react = _interopRequireWildcard(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _htmlReactParser = _interopRequireDefault(require("html-react-parser"));

var _router = require("@reach/router");

var _antd = require("antd");

var _icons = require("@ant-design/icons");

var _Caption = _interopRequireDefault(require("./Caption"));

var _Select = _interopRequireDefault(require("./Select"));

var _utils = require("../utils");

var _redux = require("../redux");

var _templateObject;

var LanguageList = function LanguageList(props) {
  var _site$languages, _site$languages$langu, _site$languages2, _site$languages2$lang;

  var onChange = props.onChange;

  var _ref2 = (0, _redux.useAppSelector)(function (state) {
    return state;
  }),
      _ref2$cms = _ref2.cms,
      site = _ref2$cms.site,
      _ref2$cms$editor = _ref2$cms.editor,
      post = _ref2$cms$editor.post,
      postHasChanged = _ref2$cms$editor.postHasChanged,
      siteHasChanged = _ref2$cms$editor.siteHasChanged;

  var dispatch = (0, _redux.useAppDispatch)();

  var _ref3 = (0, _react.useState)(''),
      _ref4 = _slicedToArray(_ref3, 2),
      loading = _ref4[0],
      setLoading = _ref4[1];

  var handleTranslatePost = /*#__PURE__*/function () {
    var _ref5 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(_ref) {
      var id, language;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              id = _ref.id, language = _ref.language;
              setLoading(language);
              dispatch(_redux.postActions.translatePost({
                id: id,
                language: language
              }));
              setLoading('');

            case 4:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function handleTranslatePost(_x) {
      return _ref5.apply(this, arguments);
    };
  }();

  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_antd.Space, {
    direction: "vertical",
    size: 20
  }, /*#__PURE__*/_react.default.createElement(_Select.default, {
    label: "Language",
    value: (post === null || post === void 0 ? void 0 : post.language) || 'none',
    onChange: onChange
  }, !(post !== null && post !== void 0 && post.language) && /*#__PURE__*/_react.default.createElement(_antd.Select.Option, {
    value: "none"
  }, "Select..."), site === null || site === void 0 ? void 0 : (_site$languages = site.languages) === null || _site$languages === void 0 ? void 0 : (_site$languages$langu = _site$languages.languages) === null || _site$languages$langu === void 0 ? void 0 : _site$languages$langu.map(function (o) {
    return /*#__PURE__*/_react.default.createElement(_antd.Select.Option, {
      key: o.id,
      value: o.slug,
      children: o.name
    });
  })), (post === null || post === void 0 ? void 0 : post.language) && /*#__PURE__*/_react.default.createElement(_antd.Space, {
    direction: "vertical",
    size: 6
  }, /*#__PURE__*/_react.default.createElement(_Caption.default, {
    children: "Translations"
  }), /*#__PURE__*/_react.default.createElement(_antd.List, {
    itemLayout: "vertical",
    size: "small",
    bordered: true,
    dataSource: site === null || site === void 0 ? void 0 : (_site$languages2 = site.languages) === null || _site$languages2 === void 0 ? void 0 : (_site$languages2$lang = _site$languages2.languages) === null || _site$languages2$lang === void 0 ? void 0 : _site$languages2$lang.filter(function (p) {
      return p.slug !== (post === null || post === void 0 ? void 0 : post.language);
    }),
    renderItem: function renderItem(language) {
      var _post$translations;

      var icon = null;

      var _onClick = function _onClick() {};

      var tooltip = '';
      var title = '';

      if (post !== null && post !== void 0 && (_post$translations = post.translations) !== null && _post$translations !== void 0 && _post$translations[language.slug]) {
        var _site$postTypes, _site$postTypes$post$, _site$postTypes$post$2, _site$postTypes$post$3, _post$translations2;

        tooltip = 'Edit translation';
        icon = /*#__PURE__*/_react.default.createElement(_icons.EditTwoTone, null);

        _onClick = function _onClick() {
          return (0, _router.navigate)((0, _utils.generateSlug)({
            site: site,
            postTypeID: post.postTypeID,
            postID: post.translations[language.slug],
            leadingSlash: true
          }));
        };

        title = site === null || site === void 0 ? void 0 : (_site$postTypes = site.postTypes) === null || _site$postTypes === void 0 ? void 0 : (_site$postTypes$post$ = _site$postTypes[post === null || post === void 0 ? void 0 : post.postTypeID]) === null || _site$postTypes$post$ === void 0 ? void 0 : (_site$postTypes$post$2 = _site$postTypes$post$.posts) === null || _site$postTypes$post$2 === void 0 ? void 0 : (_site$postTypes$post$3 = _site$postTypes$post$2[post === null || post === void 0 ? void 0 : (_post$translations2 = post.translations) === null || _post$translations2 === void 0 ? void 0 : _post$translations2[language.slug]]) === null || _site$postTypes$post$3 === void 0 ? void 0 : _site$postTypes$post$3.title;
      } else {
        var isLoading = loading === language.slug;
        tooltip = 'Add translation';
        icon = /*#__PURE__*/_react.default.createElement(_icons.PlusCircleTwoTone, {
          spin: isLoading
        });

        _onClick = function _onClick() {
          return !isLoading && handleTranslatePost({
            id: post.id,
            language: language.slug
          });
        };
      }

      return /*#__PURE__*/_react.default.createElement(_antd.Popconfirm, {
        placement: "bottomRight",
        title: "Discard unsaved changes?",
        onConfirm: _onClick,
        disabled: !postHasChanged && !siteHasChanged
      }, /*#__PURE__*/_react.default.createElement(_antd.List.Item, {
        key: language.id,
        extra: /*#__PURE__*/_react.default.createElement(IconContainer, null, /*#__PURE__*/_react.default.createElement(_antd.Tooltip, {
          title: tooltip,
          placement: "left"
        }, /*#__PURE__*/_react.default.createElement(_antd.Button, {
          type: "text",
          shape: "circle",
          icon: icon,
          onClick: function onClick() {
            return !postHasChanged && !siteHasChanged && _onClick();
          }
        })))
      }, /*#__PURE__*/_react.default.createElement(_antd.Space, null, /*#__PURE__*/_react.default.createElement(IconContainer, {
        children: language.flag && (0, _htmlReactParser.default)(language.flag)
      }), title)));
    }
  }))));
};

var IconContainer = _styledComponents.default.div(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2.default)(["\n  display: flex;\n  align-items: center;\n  height: 22px;\n  width: 22px;\n"])));

var _default = LanguageList;
exports.default = _default;